import { useEffect, useState } from 'react';
import { ColumnGrouping} from '@refinitiv-ui/efx-grid/extensions';
import WealthPackages from './WealthPackages';
import { fetchData, textWithIcon, styles, onCellClicked } from './Helpers';
import { commentImg, doubleTickImg, resolveImage } from "../../images/ImageResolver";

export default function SocialMeasures() {
  const [wealth, setWealth] = useState(false);
  const [fullData, setFullData] = useState([]);
  const [descData, setDescData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [mergedData, setMergedData] = useState([]);
  const [loading, setLoading] = useState(true);

  function searchEvent(val) {    
    setSearchData(mergedData.filter(item => item.fieldname.toLowerCase().includes(val.toLowerCase())));
  }

  useEffect(() => {
    function transformData(data) {
      return data.filter(item => (item.pillar === "Measures" && item.category === "Social"));
    }

    function transformDescData(data) {
      return data.filter(item => (item.pillar === "Social"));
    }

    fetchData("Fields_in_Package").then((res) => {
      setFullData(transformData(res));
    });
    fetchData("Field_Description").then((res) => {
      setDescData(transformDescData(res));
    });
    
  }, []);

  useEffect(() => {
    const grid = document.getElementById('grid');
    if(!wealth){
      grid.addEventListener("click", onCellClicked);
    }
  }, [wealth]);

  useEffect(() => {
    function transformMultiLineData(data){
      return data.map(item => {
        return {
          ...item,
          fieldname: item.fieldname + "," + (item.category || "")
        }
      });
    }

    function mergeData() {
      let mergedData = fullData.map(item => {
        let descItem = descData.find(desc => desc.title === item.fieldname);
        return { ...item, ...descItem };
      });
      return mergedData;
    }

    if (fullData.length > 0 && descData.length > 0) {
      setMergedData(transformMultiLineData(mergeData()));
      setLoading(false);
    }
  }, [fullData, descData]);

  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { id: "c1", name: '', field: 'fieldname', width: 2, scalable: true, binding: cellWithMultipleLines, headerBinding: headerWithColor.bind(null, "#F5F6F8") },
      { id: "c2", name: 'Scores', field: 'publicScores', width: 1.5, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#F1F3FF") },
      { id: "c21", name: 'Measures & Scores', field: '', width: 1.5 },
      { id: "c3", name: 'Scores', field: 'privateScores', width: 1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#E0E8FF"), styles: styles, },
      { id: "c4", name: 'Measures & Scores', field: 'privatePackage', width: 1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#E0E8FF"), styles: styles,  },
      { id: "c5", name: 'Scores', field: 'professionalScores', width: 1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#F1F3FF") },
      { id: "c6", name: 'Measures & Scores', field: 'professionalPackage', width:1, scalable: true, binding: textWithIcon, headerBinding: headerWithColor.bind(null, "#F1F3FF") },
      { id: "c7", name: 'API', field: 'api', width:1, scalable: true, binding: textWithIcon },
      { id: "c8", name: 'Bulk', field: 'bulk', width:1, scalable: true, binding: textWithIcon }
    ]

    function headerWithLink(name, text, i, color, cell) {
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let link = content._link = document.createElement("ef-icon");
        link.icon = "link";
        link.style.color = "blue";
        content.addEventListener("click", function(arg) {
          arg.stopPropagation();
          setWealth(true);
        });
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(link);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = name;
      content._span2.textContent = text;
      cell.setStyle("background-color", color);
      cell.setContent(content);
    };

    function headerWithColor(color,e){
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        content.appendChild(span);
      }
      content._span.textContent = e.columnDef.getName();
      cell.setStyle("background-color", color);
      cell.setContent(content);
    }
    
    function cellWithMultipleLines(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        let data = e.data.split(',');
        content = document.createElement("div");
        // content.style.textAlign = "center";
        content.style.whiteSpace = "pre-line";
        let firstLine = document.createElement("button");
        let firstLineIcon = document.createElement("ef-icon");
        let firstLineText = document.createElement("span");
        firstLineIcon.icon = "right";
        firstLineIcon.style.marginRight = "10px";
        firstLine.style.fontWeight = "600";
        firstLine.style.color = "#0f1e8a";
        firstLine.style.backgroundColor = "transparent";
        firstLine.style.border = "none";
        firstLine.style.margin = "0px";
        firstLine.style.padding = "0px";
        firstLine.style.fontSize = "14px";
        firstLine.style.cursor = "pointer";
        firstLine.style.minHeight = "40px";
        firstLine.style.textAlign = "left";
        firstLine._firstLineIcon = firstLineIcon;
        firstLine.appendChild(firstLineIcon);
        firstLineText.textContent = data[0];
        firstLine.appendChild(firstLineText);
        content._firstLine = firstLine;
        content.appendChild(firstLine);
        content.appendChild(document.createElement("br"));

        let secondLine = document.createElement("ef-pill");
        secondLine.style.fontWeight = "400";
        secondLine.style.backgroundColor = "#e5e8ff";
        secondLine.style.color = "#0a0f5c";
        secondLine.style.border = "none";
        secondLine.style.padding = "12px 20px";
        secondLine.style.margin = "0px 25px";
        secondLine.style.borderRadius = "4px";
        secondLine.style.fontSize = "12px";
        content._secondLine = secondLine;
        content.appendChild(secondLine);
        content._secondLine.textContent = data[1]

        content.addEventListener("click", function() {
          if (firstLineIcon.icon === "right") {
            firstLineIcon.icon = "down";
          } else {
            firstLineIcon.icon = "right";
          }
        });
      }
      cell.setContent(content);
    }

    let onRowExpansionBinding = function(e) {
      let rowData = e.originalRowData;
      let rowIndex = e["rowIndex"];
      let section = e["section"];
      let cell = section.stretchCell(0, rowIndex, true);
      let indiItems = {
        "Data type (dt)": "dataType",
        "Units": "units",
        "Item Code": "itemCode",
        "Hierarchy": "hierarchy",
        "Polarity": "polarity",
        "Included in Score": "included",
        "Default Values": "default",
        "ESG Scores Additional Normalization": "additional"
      }
      if (e.rowExpansion && rowData) {
        // render
        cell.setStyle("backgroundColor", "#FFFFF");
        section.setRowHeight(rowIndex, 450); // Customized height

        let expContent = cell.getContent();
        if (!expContent || !expContent._myExpansion) {
          expContent = document.createElement("div");
          expContent._myExpansion = true;

          let desc = expContent._desc = document.createElement("ef-layout");
          desc.style.display = "flex";
          desc.style.marginTop = "20px";
          desc.style.paddingLeft = "5px";
          let secondLine = expContent._secondLine = document.createElement("ef-layout");
          secondLine.style.display = "flex";
          secondLine.style.paddingBottom = "10px";
          let thridLine = expContent._thirdLine = document.createElement("ef-layout");
          thridLine.style.paddingLeft = "5px";
          thridLine.style.marginTop = "10px";

          let descImage = document.createElement("img");
          descImage.src = commentImg;
          descImage.style.marginRight = "10px";
          descImage.style.width = "24px";
          descImage.style.height = "24px";
          desc.appendChild(descImage);
          let descText = document.createElement("h2");
          descText.textContent = "Description";
          descText.style.fontWeight = "600";
          descText.style.fontSize = "16px";
          descText.style.color = "#001eff";
          descText.style.margin = "0px";
          desc.appendChild(descText);

          let descLayout = document.createElement("ef-layout");
          let p = document.createElement("p");
          p.textContent = rowData.description || "No description available.";
          p.style.margin = "0px";
          descLayout.style.width = "60%";
          descLayout.style.fontWeight = "400";
          descLayout.style.backgroundColor = "transparent";
          descLayout.style.color = "#666666";
          descLayout.style.border = "none";
          descLayout.style.padding = "10px 30px 10px 0px";
          descLayout.style.margin = "10px 5px";
          p.style.fontSize = "16px";
          p.style.whiteSpace = "pre-line";
          p.style.marginBottom = "20px";
          descLayout.appendChild(p);

          let table = document.createElement("table");
          table.style.width = "100%";
          table.style.borderCollapse = "collapse";
          table.style.marginTop = "40px";
          let thead = document.createElement("thead");
          let tbody = document.createElement("tbody");
          table.appendChild(thead);
          table.appendChild(tbody);

          let headerRow = document.createElement("tr");
          headerRow.style.backgroundColor = "#f1f1f1";
          headerRow.style.borderBottom = "1px solid #dddbdc";
          headerRow.style.color = "blue"
          headerRow.style.fontWeight = "700";
          headerRow.style.fontSize = "14px";
          let header1 = document.createElement("th");
          header1.textContent = "DP API Field Name";
          header1.style.textAlign = "left";
          header1.style.padding = "15px 10px";
          headerRow.appendChild(header1);
          thead.appendChild(headerRow);
          let header2 = document.createElement("th");
          header2.textContent = "DP Bulk Field Name";
          header2.style.textAlign = "left";
          header2.style.padding = "15px 10px";
          headerRow.appendChild(header2);

          let dataRow = document.createElement("tr");
          dataRow.style.borderBottom = "1px solid #dddbdc";
          dataRow.style.fontWeight = "400";
          dataRow.style.color = "#666666";
          dataRow.style.fontSize = "14px";
          let data1 = document.createElement("td");
          data1.textContent = rowData.apiFieldname;
          data1.style.padding = "15px 10px";
          dataRow.appendChild(data1);
          let data2 = document.createElement("td");
          data2.textContent = rowData.bulkFieldname;
          data2.style.padding = "15px 10px";
          dataRow.appendChild(data2);
          tbody.appendChild(dataRow);
          table.appendChild(thead);
          table.appendChild(tbody);
          descLayout.appendChild(table);
          
          secondLine.appendChild(descLayout);

          let indiLayout = document.createElement("ef-layout");
          indiLayout.style.fontWeight = "400";
          indiLayout.style.backgroundColor = "#f8f8f8";
          indiLayout.style.color = "#1a1a1a";
          indiLayout.style.border = "none";
          indiLayout.style.padding = "10px 20px";
          indiLayout.style.margin = "10px 5px";
          indiLayout.style.fontSize = "16px";

          Object.entries(indiItems).forEach(([key, value]) => {
            let indiDiv = document.createElement("div");
            indiDiv.style.marginBottom = "10px";
            indiDiv.style.textTransform = "capitalize";
            let indiText = document.createElement("span");
            indiText.style.display = "inline-block";
            indiText.style.marginTop = "5px";
            indiText.innerHTML = key;
            indiDiv.appendChild(indiText);
            let indiPill = document.createElement("ef-pill");
            indiPill.style.fontWeight = "400";
            const val = String(rowData[value]).toLowerCase(); 
            if (val === "positive" || val === "y") {
              indiPill.style.backgroundColor = "#87dca7";
              indiPill.style.color = "#333333";
              indiPill.textContent = rowData[value];
            } else if (val === "negative") {
              indiPill.style.backgroundColor = "#faa8b1";
              indiPill.style.color = "#333333";
              indiPill.textContent = rowData[value];
            } else if (val === "1") {
              indiPill.style.backgroundColor = "#87dca7";
              indiPill.style.color = "#333333";
              indiPill.textContent = rowData[value];
            } else if (val === "0") {
              indiPill.style.backgroundColor = "#faa8b1";
              indiPill.style.color = "#333333";
              indiPill.textContent = rowData[value];
            }else if (val === "") {
              indiPill.style.backgroundColor = "#faa8b1";
              indiPill.style.color = "#333333";
              indiPill.textContent = "N/A";
            } else {
              indiPill.style.backgroundColor = "#e8e8e8";
              indiPill.style.color = "#333333";
              indiPill.textContent = rowData[value];
            }
            indiPill.style.border = "none";
            indiPill.style.padding = "14px 20px";
            indiPill.style.margin = "5px 15px";
            indiPill.style.borderRadius = "20px";
            indiPill.style.float = "right";
            indiPill.style.fontSize = "14px";
            indiPill.style.fontWeight = "400";
            indiPill.style.minWidth = "120px";
            indiDiv.appendChild(indiPill);
            indiLayout.appendChild(indiDiv);
          });
        
          secondLine.appendChild(indiLayout);

          expContent.appendChild(desc);
          expContent.appendChild(secondLine);
          expContent.appendChild(thridLine);
        }

        rowData = e.originalRowData;
        cell.setContent(expContent);
      } else {
        // dispose
        cell = section.stretchCell(0, rowIndex, false);
        cell.setStyle("backgroundColor", "");
        section.setRowHeight(rowIndex, section.getDefaultRowHeight()); // Default height
      }
    }

    if(!wealth){
      grid.config = {
        columnReorder: true,
        columns: columns,
        rowHeight: 90,
        headerRowHeight: 60,
        dataModel: {
          data: searchData.length > 0 ? searchData : mergedData,
        },
        columnGrouping: {
          groupDefinitions: [
            {
              id: "g1",
              children: ["c2", "c21"],
              render: function(e) {
                var cell = e.cell;
                headerWithLink("PUBLIC", "Non Professional", "free", "#FFFFFF", cell)
              }
            },
            {
              id: "g2",
              children: ["c3", "c4"],
              render: function(e) {
                var cell = e.cell;
                headerWithLink("PRIVATE", "Non Professional", "private", "#F1F3FF", cell)
              }
            },
            {
              id: "g3",
              children: ["c5", "c6"],
              render: function(e) {
                var cell = e.cell;
                headerWithLink("INTERNAL PROFESSIONAL", "Private", "professional", "#FFFFFF", cell)
              }
            },
            {
              id: "g4",
              name: "COMMERCIAL PACKAGE",
              alignment: "center",
              children: ["g1", "g2", "g3"],
              render: function(e) {
                var cell = e.cell;
                var groupNode = e.groupNode;
                cell.setStyle("background-color", "#F1F1F1");
                cell.setStyle("border-right", "1px solid #f5f6f8");
                cell.setStyle("border-bottom", "1px solid #f5f6f8");
                cell.setContent(groupNode.name);
              }
            },
            {
              id: "g5",
              name: "AVAILABLE IN",
              alignment: "center",
              children: ["c7", "c8"],
              render: function(e) {
                var cell = e.cell;
                var groupNode = e.groupNode;
                cell.setStyle("background-color", "#F1F1F1");
                cell.setStyle("border-bottom", "1px solid #f5f6f8");
                cell.setContent(groupNode.name);
              }
            },
          ]
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
          colIndex: 0,
          sortOrder: "a"
          },
        },
        rowExpansionBinding: onRowExpansionBinding,
        extensions: [
          new ColumnGrouping()
        ]
      }
    }
  }, [ searchData, mergedData, wealth]);

  return (
    <div className='main-div'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      {wealth && (
        <div>
          <ef-button className="back-button" icon="back" onClick={() => setWealth(false)}>Back</ef-button>
          <WealthPackages />
        </div>
      )}
      {!wealth && (
        <div>
          <h4>Content Coverage Per Commercial Package - Social Measures</h4>
          <ef-layout flex style={{ marginTop: '20px' }}>
            <ef-layout>
              <input
                className='search-field'
                type="text"
                placeholder="Type to search..."
                onChange={(e) => searchEvent(e.target.value)}
              />
            </ef-layout>
          </ef-layout>
          <efx-grid id="grid" className="esg-grid"></efx-grid>
          <p className='commentP'><img src={doubleTickImg} alt="Double Tick" /> The values for the following measures and indicators are only available to Redistribution customers for derivation use only; redistribution and display of the actual values are NOT allowed.</p>
        </div>
      )}
    </div>
  );
}